import React, { useEffect, useState } from "react";
import DeleteBookmark from "./DeleteBookmark";
import axios from "../../../../axios";
import CreateBookMarkPopup from "./CreateBookMarkPopup";

export default function Bookmark({
  user,
  content,
  book,
  chapter,
  forward,
  setCurrentPage,
  componentRerenderFlag,
  setComponentRerenderFlag,
}) {
  const [isEditing, setIsEditing] = useState(false);
  const [deleteBookmark, setDeleteBookmark] = useState(false);
  const [bookmarkText, setBookmarkText] = useState();
  const [contentBookmark, setContentBookmark] = useState([]);
  const [editIndex, setEditIndex] = useState(-1);
  const [errorMsg, setErrorMsg] = useState("");
  const [viewErrorPop, setViewErrorPop] = useState(false);
  const [clickedBookmark, setClickedBookmark] = useState();
  useEffect(() => {
    try {
      const helper = async () => {
        setContentBookmark([]);
        if (user?.id && content?.id) {
          let res = await axios.get(
            `/cm/library/book/getUserBookmarksByUserIDAndContentInfoID?user_id=${user?.id}&contentInfo_id=${content?.id}`
          );
          res && setContentBookmark(res.data.data.bookmarksID);
        }
      };
      helper();
    } catch (error) {
      console.log("error", error);
    }
  }, [content, user, componentRerenderFlag]);
  const handleEditClick = (index, bookmarkName) => {
    setIsEditing(true);
    setEditIndex(index);
    setBookmarkText(bookmarkName);
  };
  const handleDoneClick = () => {
    if (editIndex !== -1) {
      const updatedContentBookmark = [...contentBookmark];
      updatedContentBookmark[editIndex].bookmarkName = bookmarkText;
      setContentBookmark(updatedContentBookmark);
    }
    setIsEditing(false);
    setEditIndex(-1);
  };
  const handleBookmarkUpdate = async () => {
    let body = {
      user_id: user?.id,
      contentInfo_id: content?.id,
      bookmark_id: clickedBookmark?.id,
      bookmarkNewName: bookmarkText,
      bookmarkNewTimeStamp: clickedBookmark?.bookmarkTimeStamp,
    };
    try {
      let res = await axios.post(
        `/cm/library/book/updateUserBookmarksByUserIDAndContentInfoID`,
        body
      );
      if (res.status === 200) {
        // window.location.reload();
        setComponentRerenderFlag((prevFlag) => !prevFlag);
        setIsEditing(false);
      }
    } catch (error) {
      if (error) {
        setErrorMsg(error.response.data.message);
        setViewErrorPop(true);
      }
    }
  };

  console.log(content, "asdasd");

  return (
    <>
      {contentBookmark?.length > 0 ? (
        contentBookmark.map((obj, index) => (
          <div
            className={
              isEditing && editIndex === index
                ? "totalBookmarkContainerEdit mt-3"
                : "totalBookmarkContainer mt-3"
            }
            key={index}
          >
            <div className="d-flex justify-content-between">
              <div className="chapterNamebookmark">{chapter}</div>
              <div className="daysAgo">
                {content?.fileInfo?.fileType === "pdf" ||
                content?.fileInfo?.fileType === "e-book"
                  ? `Page ${obj?.bookmarkTimeStamp}`
                  : `${(obj?.bookmarkTimeStamp / 60).toFixed(2)} min`}{" "}
              </div>
              <div className="d-flex gap-4">
                <div
                  className="editeNote"
                  onClick={() => {
                    handleEditClick(index, obj?.bookmarkName);
                    setClickedBookmark(obj);
                  }}
                >
                  Edit
                </div>
                <div
                  className="Deletenote"
                  onClick={(e) => {
                    setDeleteBookmark(true);
                    setClickedBookmark(obj);
                  }}
                >
                  Delete
                </div>
                <div
                  className="viewNote"
                  onClick={() => {
                    if (
                      content?.fileInfo?.fileType === "pdf" ||
                      content?.fileInfo?.fileType === "e-book"
                    ) {
                      setCurrentPage(Number(obj?.bookmarkTimeStamp));
                      return;
                    }
                    forward(obj?.bookmarkTimeStamp);
                  }}
                >
                  View
                </div>
                {console.log("obj?.bookmarkTimeStamp", obj)}
              </div>
            </div>
            <div className="bookmarkText mt-2">
              {isEditing && editIndex === index ? (
                <div className="d-flex align-items-center gap-3">
                  <textarea
                    className="bookmarkTextArea align-items-center"
                    value={bookmarkText}
                    onChange={(e) => setBookmarkText(e.target.value)}
                  />
                  <div
                    className="d-flex gap-2"
                    onClick={() => {
                      handleBookmarkUpdate();
                    }}
                  >
                    <div>
                      <img
                        style={{ cursor: "pointer" }}
                        src="/LibraryImg/EditDone.png"
                        alt="replie icon"
                        onClick={handleDoneClick}
                      />
                    </div>
                    <span>Done</span>
                  </div>
                  <div
                    className="d-flex gap-2"
                    onClick={() => {
                      setIsEditing(false);
                    }}
                  >
                    <div>
                      <img
                        style={{ cursor: "pointer" }}
                        src="/LibraryImg/EditDiscard.png"
                        alt="replie icon"
                      />
                    </div>
                    <span>Discard</span>
                  </div>
                </div>
              ) : (
                obj?.bookmarkName
              )}
            </div>
          </div>
        ))
      ) : (
        <div className="flex flex-col items-center justify-center py-16 text-center">
          <h2 className="text-xl font-semibold text-gray-700 mt-4">
            No Bookmarks Yet
          </h2>

          <p className="text-gray-500 mt-2 max-w-xs">
            You haven’t added any bookmarks for this chapter. Start reading to
            save important points instantly.
          </p>
        </div>
      )}
      {deleteBookmark && (
        <DeleteBookmark
          handleCloseBookmarkDeltePopup={() => {
            setDeleteBookmark(false);
          }}
          reRenderPage={() => setComponentRerenderFlag((prevFlag) => !prevFlag)}
          data={clickedBookmark}
          userData={user}
          contentId={content?.id}
        />
      )}
      {console.log("viewErrorPop", viewErrorPop)}
      {viewErrorPop && (
        <CreateBookMarkPopup
          errorMsg={errorMsg}
          setViewErrorPop={setViewErrorPop}
        />
      )}
    </>
  );
}
